<template>
    <div class="jibenWrap">
        <Heads></Heads>
        <div class="jiben_content">
            我是基本信息
        </div>
    </div>
</template>
<script>
import Heads from "@/components/Heads.vue"
export default {
    name: "Jiben",
    data(){
        return{

        }
    },
    components:{
        Heads
    }
}
</script>
<style lang="scss" scoped>
.jibenWrap{
    width: 100%;

    .jiben_content{
        width: 75%;
        margin: 0 auto;
        background: #fff;
    }
}
</style>